import { Fragment } from "react";

import ModalImage from "react-modal-image";
import { useHistory } from "react-router-dom";

import EditIcon from "@material-ui/icons/Edit";

import { useNewSubscriberContext } from "../../Context/NewSubsciberContext";
import { setStatusBackToSummary } from "../../Context/NewSubscriberAction";

const SIGINATURES = {
  JVBERi0: "application/pdf",
  iVBORw0KGgo: "image/png",
  "/9j/": "image/jpg",
};

const IMAGE_TYPES = {
  ChqImage: {
    // label: "Cancelled Cheque/Passbook or eStatement",
    label: "Tier I Bank Cheque Image",
    docName: "ChqDocumentName",
    docData: "ChqImage",
  },
  Tier1ChequeImage: {
    // label: "Cancelled Cheque/Passbook or eStatement",
    label: "Tier II Bank Cheque Image",
    docName: "Tier1ChequeDocumentName",
    docData: "Tier1ChequeImage",
  },
  PhotoImage: {
    docName: "PhotoDocumentName",
    docData: "PhotoImage",
    label: "Photograph",
  },
  SigImage: {
    docName: "SignatureDocumentName",
    docData: "SigImage",
    label: "Signature",
  },
  PanImage: {
    docName: "PanDocumentName",
    docData: "PanImage",
    label: "Pan Card",
  },
};

const UploadedDocuments = () => {
  const history = useHistory();
  const { dispatch: contextDispatch, summary } = useNewSubscriberContext();
  const imageDetails = summary?.data?.objPhotosigDetails[0] || {};

  const images = Object.keys(IMAGE_TYPES).map((key) => {
    const { docName, docData, label } = IMAGE_TYPES[key];
    if (!!imageDetails[docData]) {
      const fileType = detectMimeType(imageDetails[docData]);

      if (fileType === "image/png" || fileType === "image/jpg") {
        return {
          docData:
            "data:" +
            detectMimeType(imageDetails[key]) +
            ";base64," +
            imageDetails[key],
          docName: imageDetails[docName],
          label: label,
        };
      }
    }
    return null;
  });
  const back = () => {
    contextDispatch(setStatusBackToSummary(true));
    history.push({
      pathname: "/nps/AddSubs/upload-documents",
    });
  };
  return (
    <div>
      <div className="new-subscriber-container">
        <div
          style={{
            paddingLeft: "16px",
            fontSize: "18px",
            color: "#000000",
            fontWeight: "400",
            opacity: "0.8",
            paddingBottom: "4px",
          }}
        >
          UPLOADED DOCUMENTS
        </div>
        <EditIcon className="cursor" onClick={back} />
      </div>
      <div className="container-margin" style={{ display: "flex" }}>
        {" "}
        {images.map((image, index) => {
          return (
            <Fragment key={index}>
              {!!image && !!image.docData && (
                <>
                  <ImageBox
                    src={image.docData}
                    alt={image.label}
                    name={image.docName}
                  />
                </>
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default UploadedDocuments;

export const detectMimeType = (b64) => {
  for (var s in SIGINATURES) {
    if (b64?.indexOf(s) === 0) {
      return SIGINATURES[s];
    }
  }
};

export const ImageBox = (props) => {
  return (
    <Fragment>
      <div className="image-container">
        <p>
          <b>{props.alt}</b>
        </p>
        <ModalImage
          small={props.src}
          large={props.src}
          className="image-modal"
        />
        <div>
          <p style={{ textAlign: "center" }}>{props.name}</p>
        </div>
      </div>
    </Fragment>
  );
};
